<template>
  <div class="container">
    <van-cell-group>
      <van-field
        v-model="username"
        label="真实姓名"
        right-icon="edit"
        autosize
        rows="1"
        type="textarea"
        required
      />
      <van-field
        v-model="cert_type"
        clickable
        readonly
        label="证件类型"
        :value="cert_type"
        @click="cert_typeshowPicker = true"
        ref="cert_type"
        required
      />
      <van-popup v-model="cert_typeshowPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="cert_type_columns"
          value-key="value"
          @cancel="cert_typeshowPicker = false"
          @confirm="cert_typeonConfirm"
        />
      </van-popup>
      <van-field
        v-model="cert"
        clearable
        :readonly="readonlychoose"
        label="证件号码"
        autosize
        rows="1"
        type="textarea"
        right-icon="edit"
        required
      />
      <van-field
        v-model="politics_face"
        clickable
        readonly
        label="政治面貌"
        :value="politics_face"
        @click="politics_faceshowPicker = true"
        right-icon="arrow"
        ref="politics_face"
        required
      />
      <van-popup v-model="politics_faceshowPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="politics_face_columns"
          value-key="value"
          @cancel="politics_faceshowPicker = false"
          @confirm="politics_faceonConfirm"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        label="性别"
        :value="gender"
        @click="gendershowPicker = true"
        right-icon="arrow"
        ref="gender"
        required
      />
      <van-popup v-model="gendershowPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="gender_columns"
          value-key="value"
          @cancel="gendershowPicker = false"
          @confirm="genderonConfirm"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        @click="birthdayshowPicker = true"
        label="出生年月"
        v-model="birthday"
        right-icon="arrow"
        :value="birthday"
        required
      />
      <van-popup v-model="birthdayshowPicker" round position="bottom">
        <van-picker
          show-toolbar
          value-key="value"
          :columns="birthday_columns"
          @cancel="birthdayshowPicker = false"
          @confirm="birthdayonConfirm"
        />
      </van-popup>
      <van-field v-model="native_place" label="籍贯" />
      <van-field
        v-model="guojia"
        label="国家"
        autosize
        rows="1"
        type="textarea"
        required
      />
      <van-field
        readonly
        clickable
        label="文化程度"
        v-model="wenhua"
        right-icon="arrow"
        :value="wenhua"
        @click="wenhuashowPicker = true"
        required
      />
      <van-popup v-model="wenhuashowPicker" round position="bottom">
        <van-picker
          show-toolbar
          value-key="value"
          :columns="wenhua_columns"
          @cancel="wenhuashowPicker = false"
          @confirm="wenhuaonConfirm"
        />
      </van-popup>
      <van-field v-model="minzu" label="民族" required />
      <van-field
        v-model="school"
        label="毕业院校"
        autosize
        rows="1"
        type="textarea"
      />
      <van-field
        v-model="major"
        label="专业"
        autosize
        rows="1"
        type="textarea"
      />
      <van-field
        v-model="compony"
        label="工作单位"
        autosize
        rows="1"
        type="textarea"
      />
      <van-field
        v-model="compony_addr"
        label="单位地址"
        autosize
        rows="1"
        type="textarea"
      />
      <van-field v-model="zhicheng" label="职称" />
      <van-field v-model="zhiwu" label="职务" />
    </van-cell-group>
    <van-cell-group>
      <van-field clearable label="手机号码" v-model="phone" readonly required />
      <!-- <van-field
        readonly
        autosize
        rows="1"
        type="textarea"
        label="所在城市"
        v-model="area"
        :value="area"
      /> -->
      <!-- <van-popup v-model="areashowPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="area_columns"
          value-key="name"
          @cancel="areashowPicker = false"
          @confirm="areaonConfirm"
          @change="areachange"
        />
      </van-popup> -->
      <van-field
        readonly
        clickable
        autosize
        rows="1"
        type="textarea"
        label="注册地址"
        v-model="street"
        :value="street"
        @click="streetclick"
        required
      /><!-- 判断是否选择了省市区 streetshowPicker = true -->
      <van-popup v-model="streetshowPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="street_columns"
          value-key="name"
          @cancel="streetshowPicker = false"
          @confirm="streetonConfirm"
          @change="streetchange"
        />
      </van-popup>
    </van-cell-group>
    <van-cell-group>
      <van-field
        readonly
        v-model="skill"
        clickable
        rows="1"
        autosize
        label="个人技能"
        type="textarea"
        @click="skillshow = true"
      />
      <van-popup
        v-model="skillshow"
        position="bottom"
        :style="{ height: '50%' }"
      >
        <div class="flex">
          <p @click="skillshow = false">取消</p>
          <p @click="skillcomfirm">完成</p>
        </div>
        <van-checkbox-group style="margin-top: 15vw" v-model="result">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in list"
              clickable
              :key="item.index"
              :title="`${item.value}`"
              @click="toggle(index)"
            >
              <template #right-icon>
                <van-checkbox
                  :name="`${item.id}-${item.value}`"
                  ref="checkboxes"
                />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </van-popup>
      <!-- <van-field
        clearable
        label="空闲时间"
        v-model="freetime"
        rows="1"
        autosize
        type="textarea"
      /> -->
    </van-cell-group>
    <van-button
      type="warning"
      :loading="loading"
      loading-text="加载中..."
      @click="submit"
      >注册加入</van-button
    >
  </div>
</template>
<script>
export default {
  name: "register",
  data() {
    return {
      loading: false,
      username: "",
      cert: "",
      politics_face: "",
      gender: "",
      cert_type: "身份证",
      birthday: "",
      native_place: "",
      guojia: "中国",
      wenhua: "",
      minzu: "汉族",
      school: "",
      major: "",
      compony: "",
      compony_addr: "",
      zhicheng: "",
      zhiwu: "",
      gendershowPicker: false,
      politics_faceshowPicker: false,
      cert_typeshowPicker: false,
      streetshowPicker: false,
      areashowPicker: false,
      wenhuashowPicker: false,
      skillshow: false,
      birthdayshowPicker: false,
      politics_face_columns: [
        {
          value: "中共党员",
          id: "1",
        },
        {
          value: "中共预备党员",
          id: "2",
        },
        {
          value: "共青团员",
          id: "3",
        },
        {
          value: "民革党员",
          id: "4",
        },
        {
          value: "民盟盟员",
          id: "5",
        },
        {
          value: "民建会员",
          id: "6",
        },
        {
          value: "民进会员",
          id: "7",
        },
        {
          value: "农工党党员",
          id: "8",
        },
        {
          value: "致公党党员",
          id: "9",
        },
        {
          value: "九三学社社员",
          id: "10",
        },
        {
          value: "台盟盟员",
          id: "11",
        },
        {
          value: "无党派人士",
          id: "12",
        },
        {
          value: "群众",
          id: "13",
        },
      ],
      gender_columns: [
        {
          value: "男",
          id: "1",
        },
        {
          value: "女",
          id: "2",
        },
      ],
      cert_type_columns: [
        {
          value: "身份证",
          id: "1",
        },
        {
          value: "军官证",
          id: "2",
        },
        {
          value: "护照",
          id: "3",
        },
        {
          value: "台胞证",
          id: "4",
        },
        {
          value: "港澳通行证",
          id: "5",
        },
      ],
      wenhua_columns: [
        {
          value: "初中",
          id: "1",
        },
        {
          value: "高中",
          id: "2",
        },
        {
          value: "中技",
          id: "3",
        },
        {
          value: "中专",
          id: "4",
        },
        {
          value: "大专",
          id: "5",
        },
        {
          value: "本科",
          id: "6",
        },
        {
          value: "硕士",
          id: "7",
        },
        {
          value: "博士",
          id: "8",
        },
      ],
      street_columns: [
        {
          values: [],
          defaultIndex: 0,
          className: "column1",
        },
        {
          values: [],
          defaultIndex: 0,
          className: "column2",
        },
      ],
      area_columns: [
        {
          values: [],
          defaultIndex: 0,
          className: "column1",
        },
        {
          values: [],
          defaultIndex: 0,
          className: "column2",
        },
        {
          values: [],
          defaultIndex: 0,
          className: "column3",
        },
      ],
      birthday_columns: [
        {
          values: [],
          defaultIndex: 0,
          className: "column1",
        },
        {
          values: [],
          defaultIndex: 0,
          className: "column2",
        },
        {
          values: [],
          defaultIndex: 0,
          className: "column3",
        },
      ],
      phone: "",
      area: "江苏省江阴市",
      street: "江苏省江阴市  ",
      skill: "",
      skillchoose: "",
      freetime: "",
      genderchoose: "",
      cert_typechoose: "1",
      politics_facechoose: "",
      areachoose: "320281",
      streetchoose: "",
      villagechoose: "",
      wenhuachoose: "",
      appId: "2312",
      url: "",
      img: "",
      list: [
        {
          value: "外语",
          id: "1",
        },
        {
          value: "书法",
          id: "2",
        },
        {
          value: "绘画",
          id: "3",
        },
        {
          value: "电脑维修",
          id: "4",
        },
        {
          value: "文化辅导",
          id: "5",
        },
        {
          value: "编辑写作",
          id: "6",
        },
        {
          value: "话剧",
          id: "7",
        },
        {
          value: "演讲",
          id: "8",
        },
        {
          value: "节目主持",
          id: "9",
        },
        {
          value: "电脑编程",
          id: "10",
        },
        {
          value: "摄影",
          id: "11",
        },
        {
          value: "漫画",
          id: "12",
        },
        {
          value: "唱歌",
          id: "13",
        },
        {
          value: "推拿按摩",
          id: "14",
        },
        {
          value: "创意策划",
          id: "15",
        },
        {
          value: "处理应变",
          id: "16",
        },
        {
          value: "社交外联",
          id: "17",
        },
        {
          value: "人事管理",
          id: "18",
        },
        {
          value: "平面设计",
          id: "19",
        },
      ],
      result: [],
      readonlychoose: true,
      idcard: "",
    };
  },
  created() {
    var that = this;
    //app
    this.url = "//zhuzhan.ijiangyin.com/siteapp/appClient/sign";
    var uid;
    if (!uid) {
      zjyapi.init({
        appId: that.appId,
        error: function (code, ret) {
          //失败回调,默认
          alert("初始化失败");
        },
        success: function success(ret) {
          that.queryUserInfoAll();
        },
      });
    } else {
      app.initUser({ uid: uid, mobile: mobile });
    }
    //乡村、镇、街道
    /* this.$axios({
      method:'post',
      url:'/api/common/area',
      data:this.qs.stringify({
        code:''
      })
    }).then(res => {
      console.log(res.data);
      if(res.data.code == 0){
        that.area_columns[0].values = res.data.data;
        that.area_columns[0].defaultIndex = 9;
        that.locate(that.area_columns[0].values[9].code).then(res => {
          that.area_columns[1].values = res;
          that.area_columns[1].defaultIndex = 1;
          that.locate(that.area_columns[1].values[1].code).then(res => {
            console.log(res);
            that.area_columns[2].values = res;
            that.area_columns[2].defaultIndex = 5;
            that.locate(that.area_columns[2].values[5].code).then(res => {
              that.street_columns[0].values = res;
              that.locate(that.street_columns[0].values[0].code).then(res => {
                that.street_columns[1].values = res;
              })
            })
          })
        })
      }
    }) */
    this.locate("320281").then((res) => {
      that.street_columns[0].values = res;
      that.locate(that.street_columns[0].values[0].code).then((res) => {
        //that.street_columns[1].values = res;
        that.street_columns[0].values.unshift({ code: "", name: "不选择" });
        that.street_columns[1].values.unshift({ code: "", name: "不选择" });
        console.log(that.street_columns);
      });
    });
    //出生日期数据初始化
    let yeararr = [];
    console.log(new Date().getFullYear());
    let num = new Date().getFullYear();
    for (let i = 0; i < 101; i++) {
      yeararr.push(num);
      num -= 1;
    }
    let montharr = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ];
    let dayarr = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ];
    this.birthday_columns[0].values = yeararr;
    this.birthday_columns[1].values = montharr;
    this.birthday_columns[2].values = dayarr;
  },
  watch: {
    cert_typechoose: {
      handler: function () {
        if (Number(this.cert_typechoose) == 1) {
          if (this.idcard) {
            this.cert = this.idcard;
          }
          this.readonlychoose = true;
        } else {
          this.readonlychoose = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    streetclick() {
      /* if(this.area == ''){
        this.$toast('请先选择省市区');
        return;
      } */
      this.streetshowPicker = true;
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    skillcomfirm() {
      console.log(this.result);
      let skill = [];
      let result = [];
      for (let i in this.result) {
        skill.push(this.result[i].split("-")[1]);
      }
      console.log(skill);
      this.skill = skill.join(",");
      for (let i in this.result) {
        result[i] = this.result[i].split("-")[0];
      }
      console.log(result.join(","));
      this.skillchoose = result.join(",");
      this.skillshow = false;
    },
    politics_faceonConfirm(value, index) {
      console.log(index);
      this.politics_face = value.value;
      this.politics_facechoose = value.id;
      console.log(this.politics_face);
      this.politics_faceshowPicker = false;
    },
    genderonConfirm(value, index) {
      this.gender = value.value;
      this.genderchoose = value.id;
      this.gendershowPicker = false;
    },
    cert_typeonConfirm(value, index) {
      this.cert_type = value.value;
      this.cert_typechoose = value.id;
      console.log(value);
      this.cert_typeshowPicker = false;
    },
    wenhuaonConfirm(value, index) {
      this.wenhua = value.value;
      this.wenhuachoose = value.id;
      console.log(value);
      this.wenhuashowPicker = false;
    },
    streetonConfirm(value, index) {
      let arr = [];
      for (let i in value) {
        if (value[i].code != "") {
          arr.push(value[i].name);
        }
      }
      this.street = "江苏省江阴市 " + arr.join("/");
      this.streetshowPicker = false;
      console.log(value);
      this.streetchoose = value[0].code;
      this.villagechoose = value[1].code;
    },
    streetchange(picker, value, index) {
      if (value[0].code != "") {
        this.locate(value[0].code).then((res) => {
          res.unshift({ code: "", name: "不选择" });
          picker.setColumnValues(1, res);
          this.street_columns[1].defaultIndex = 0;
        });
      } else {
        picker.setColumnValues(1, [{ code: "", name: "不选择" }]);
        this.street_columns[1].defaultIndex = 0;
      }
    },
    areaonConfirm(value, index) {
      console.log(value);
      let arr = [];
      for (let i in value) {
        arr.push(value[i].name);
      }
      this.area = arr.join("/");
      this.areashowPicker = false;
      console.log(index);
      this.areachoose = value[2].code;
      var that = this;
      this.street = "";
      this.streetchoose = "";
      this.locate(this.areachoose).then((res) => {
        that.street_columns[0].values = res;
        that.locate(that.street_columns[0].values[0].code).then((res) => {
          that.street_columns[1].values = res;
        });
      });
    },
    areachange(picker, value, index) {
      console.log(value, index);
      this.locate(value[0].code).then((res) => {
        picker.setColumnValues(1, res);
        this.area_columns[1].defaultIndex = 0;
        this.locate(picker.getValues()[1].code).then((res) => {
          picker.setColumnValues(2, res);
          this.area_columns[2].defaultIndex = 0;
        });
      });
    },
    birthdayonConfirm(value, index) {
      console.log(value, index);
      this.birthday = value.join("-");
      this.birthdayshowPicker = false;
    },
    //查询省市区
    locate(code) {
      return this.$axios({
        method: "post",
        url: "/api/common/area",
        data: this.qs.stringify({
          code: code,
          token: sessionStorage.getItem("wmtoken"),
        }),
      }).then((res) => {
        //console.log(res.data);
        if (res.data.code == 0) {
          return res.data.data;
        }
      });
    },
    //app相关开始
    //获取签名方法
    getSign: function (fun) {
      /*请求参数*/
      var paramObj = {
        httpUrl: this.url,
        type: "post",
        data: {
          appId: this.appId,
        },
      };
      /*请求调用*/
      this.httpRequest(paramObj, fun, function () {
        alert("获取签名失败错误");
      });
    },
    httpRequest: function (paramObj, fun, errFun) {
      var xmlhttp = null;
      /*创建XMLHttpRequest对象，
       *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
       * */
      if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      /*判断是否支持请求*/
      if (xmlhttp == null) {
        alert("你的浏览器不支持XMLHttp");
        return;
      }
      /*请求方式，并且转换为大写*/
      var httpType = (paramObj.type || "GET").toUpperCase();
      /*数据类型*/
      var dataType = paramObj.dataType || "json";
      /*请求接口*/
      var httpUrl = paramObj.httpUrl || "";
      /*是否异步请求*/
      var async = paramObj.async || true;
      /*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
      var paramData = paramObj.data || [];
      var requestData = "";
      for (var name in paramData) {
        requestData += name + "=" + paramData[name] + "&";
      }
      requestData =
        requestData == ""
          ? ""
          : requestData.substring(0, requestData.length - 1);
      console.log(requestData);
      /*请求接收*/
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          /*成功回调函数*/
          //获取签名数据成功:{"serverTime":null,"error":"200","msg":"成功","data":{"appSign":"b37808616bda9d71e100e0971881101d","appId":"2312""timestamp":1575953679723},"map":null}
          console.log("获取签名数据成功:" + xmlhttp.responseText);
          var obj = JSON.parse(xmlhttp.responseText);
          var data = obj.data;
          fun({
            timestamp: data.timestamp,
            sign: data.appSign,
          });
        } else {
          /*失败回调函数*/
          errFun;
        }
      };
      /*接口连接，先判断连接类型是post还是get*/
      if (httpType == "GET") {
        xmlhttp.open("GET", httpUrl, async);
        xmlhttp.send(null);
      } else if (httpType == "POST") {
        xmlhttp.open("POST", httpUrl, async);
        //发送合适的请求头信息
        xmlhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xmlhttp.send(requestData);
      }
    },
    queryUserInfoAll: function () {
      var that = this;
      this.getSign(function (sign) {
        zjyapi.queryUserInfoAll({
          sign: sign,
          params: {
            type: "2",
          },
          success: function (ret) {
            console.log("获取用户信息成功：" + ret);
            var data = JSON.parse(ret);
            if (data.uid) {
              sessionStorage.setItem("uid", data.uid);
            } else {
              alert("请登录app");
            }
            that.img = data.headimg;
            that.phone = data.mobile;
            that.idcard = data.identityId;
            that.cert = data.identityId;
            that.birthday =
              data.identityId.slice(6, 10) +
              "-" +
              data.identityId.slice(10, 12) +
              "-" +
              data.identityId.slice(12, 14);
            that.username = data.authenticationName;
            console.log(ret);
            console.log(JSON.parse(ret));
          },
          error: function (error) {
            console.log("获取用户信息失败：" + JSON.stringify(error));
          },
        });
      });
    },
    //end
    //app相关结束
    //提交注册
    submit() {
      //username,cert_type,cert,politics_face,gender,phone,area,street,skill,freetime
      this.loading = true;
      if (this.username == "") {
        this.$toast("请输入姓名");
        this.loading = false;
        return;
      }
      if (this.cert_type == "") {
        this.$toast("请选择证件类型");
        this.loading = false;
        return;
      }
      if (this.cert == "") {
        this.$toast("请输入证件号");
        this.loading = false;
        return;
      }
      if (this.politics_face == "") {
        this.$toast("请输入政治面貌");
        this.loading = false;
        return;
      }
      if (this.gender == "") {
        this.$toast("请选择性别");
        this.loading = false;
        return;
      }
      if (this.birthday == "") {
        this.$toast("请输入出生年月");
        this.loading = false;
        return;
      }
      if (this.guojia == "") {
        this.$toast("请输入国家");
        this.loading = false;
        return;
      }
      if (this.wenhuachoose == "") {
        this.$toast("请选择文化程度");
        this.loading = false;
        return;
      }
      if (this.minzu == "") {
        this.$toast("请输入民族");
        this.loading = false;
        return;
      }
      if (this.phone == "") {
        this.$toast("请输入手机号码");
        this.loading = false;
        return;
      }
      /* if(this.area == ''){
        this.$toast('请选择省市区');
        return;
      } */
      /* if(this.streetchoose == ''){
        this.$toast('请选择所在地区');
        this.loading = false;
        return;
      } */

      this.$axios({
        method: "post",
        url: "/api/member/register",
        data: this.qs.stringify({
          img: this.img,
          name: this.username,
          cert_type: this.cert_typechoose,
          cert: this.cert,
          politics_face: this.politics_facechoose,
          gender: this.genderchoose,
          mobile: this.phone,
          area: this.areachoose,
          street: this.streetchoose,
          village: this.villagechoose,
          skill: this.skillchoose,
          wenhua: this.wenhuachoose,
          birthday: this.birthday,
          native_place: this.native_place,
          guojia: this.guojia,
          minzu: this.minzu,
          school: this.school,
          major: this.major,
          compony: this.compony,
          compony_addr: this.compony_addr,
          zhicheng: this.zhicheng,
          zhiwu: this.zhiwu,
          zjy_uid: sessionStorage.getItem("uid"),
        }),
      }).then((res) => {
        console.log(res.data);
        this.loading = false;
        if (res.data.code == 0) {
          this.$router.push("/");
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.container {
  min-height: 100vh;
  background: #f2f2f2;
  padding: 10px;
}
.van-cell-group {
  margin-bottom: 10px;
  border-radius: 5px;
}
.van-button {
  border-radius: 5px;
  background: #cab586;
  margin: 20px auto;
  display: block;
  width: 50%;
  border: none;
}
.flex {
  display: flex;
  justify-content: space-between;
  padding: 5vw;
  position: fixed;
  z-index: 99;
  width: 90vw;
  background: white;
}
</style>


// WEBPACK FOOTER //
// src/components/register.vue